import { FC, useEffect, useState } from 'react';
import { Modal } from '../components/Modal';
import { IonContent } from '@ionic/react';
import { UserState } from '../user/UserState';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { Spinner } from '../components/Spinner';
import { CareMapState } from '../caremap/CareMapState';
import dayjs from 'dayjs';
import { HelperBeeViewModel } from './HelperBeeViewModel';
import { EnvConfiguration } from '../config/EnvConfiguration';
import { AppPrincipal } from '../auth/AppPrincipal';

export const HelperBeeModal: FC = () => {
    const config = useInstance(EnvConfiguration);
    const user = useInstance(AppPrincipal);

    const userState = useInstance(UserState);
    useSubscription(() => userState);

    const caremapState = useInstance(CareMapState);
    useSubscription(() => caremapState);

    const vm = useInstance(HelperBeeViewModel);
    useSubscription(() => vm);
    const isOpen = vm.isOpen();

    const [loaded, setLoaded] = useState<boolean>(false);
    useEffect(() => setLoaded(false), [isOpen]);

    const caremap = caremapState.getMostRecentCaremap();

    const params = new URLSearchParams();
    params.append('user_id', user.userId);
    params.append('avatar', userState.state.pictureUrl || '');
    params.append('age', caremap?.patient.dob ? String(dayjs().diff(caremap.patient.dob, 'year')) : '');
    params.append('loc', caremap?.patient.address || '');
    params.append('dx', caremap?.patient.diagnoses ? caremap.patient.diagnoses.map(dx => dx.diagnosis).join('|') : '');

    return (
        <Modal
            isOpen={isOpen}
            titleColor="secondary"
            title="Innerhive’s BeeLine"
            data-id="helper-bee-modal"
            closeHandler={vm.close}
        >
            <IonContent>
                <iframe
                    width="100%"
                    height="100%"
                    title="HelperBee"
                    style={{border: 'none', overflow: 'hidden'}}
                    onLoad={() => setLoaded(true)}
                    src={`${config.AI_CHAT_URL}?${params}`}
                />
                {!loaded && (
                    <Spinner centered />
                )}
            </IonContent>
        </Modal>
    );
};
